import React from 'react';
import i18n from 'i18n-js';
import { useDispatch, useSelector } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';
import withWidth from '@material-ui/core/withWidth';
import Images from 'components/Images';
import { withRouter } from 'react-router-dom';

const VehicleTypeImages = ({ id }) => {
  const dispatch = useDispatch();
  const {
    vehicleType,
    fetchingUploadVehicleTypeImage,
    fetchedUploadVehicleTypeImageSuccess,
    fetchingImageAction,
  } = useSelector((state) => state.vehicles);

  const onSetProfileImage = (payload) => {
    dispatch(vehicleActions.setVehicleTypeProfileImage(id, payload));
  };

  const onDeleteImages = (payload) => {
    dispatch(vehicleActions.deleteVehicleTypeImages(id, payload));
  };

  const onUploadImage = (payload) => {
    dispatch(vehicleActions.uploadVehicleTypeImage(id, payload));
  };

  const onReset = () => {
    dispatch(vehicleActions.resetUploadVehicleTypeImage());
  };

  return (
    <Images
      id={id}
      title={i18n.t('vehicle_types.vehicle_type_images')}
      onSetProfileImage={onSetProfileImage}
      onDeleteImages={onDeleteImages}
      onUploadImage={onUploadImage}
      onReset={onReset}
      sourceType="vehicle_type"
      images={vehicleType?.images || []}
      loading={fetchingImageAction}
      loadingUpload={fetchingUploadVehicleTypeImage}
      loadingSuccess={fetchedUploadVehicleTypeImageSuccess}
    />
  );
};

export default withWidth()(withRouter(VehicleTypeImages));
